import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

import Home from '../components/home/Home';
import YJ from '../components/home/YJ';
import GS from '../components/home/GS';
import SS from '../components/home/SS';
import WM from '../components/home/WM';


import NotFound from '../components/NotFound/NotFound';

export default class AdminRouter extends Component {
    render() {
        return (
            <Router>
                <ScrollToTop>
                    <Switch>
                        <Route path="/" exact render={() => <Redirect to="/home" push />} />
                        <Route path="/home" component={Home} />
                        <Route path="/yj" component={YJ} />
                        <Route path="/gs" component={GS} />
                        <Route path="/ss" component={SS} />
                        <Route path="/wm" component={WM} />



                        <Route path="/NotFound" component={NotFound} />
                        <Redirect to="/NotFound" />
                    </Switch>
                </ScrollToTop>
            </Router>
        )
    }
}
